'use strict';

export class Breadcrumb {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		
		this.hammer_gestures_active = true;
		
		this.$root = jQuery(`body .js-${this.id}`);
		this.$list = this.$root.find(`.js-${this.id}_list`);

		if (this.hammer_gestures_active) {
			this.$breadcrumb_inner =  this.$root.find(`.js-${this.id}_list`);
			this.container_gap = parseInt(this.$breadcrumb_inner.css('gap'), 10);
			this.items_pixel = this.calculate_width();
			this.container_width = this.$breadcrumb_inner.width();
			this.max_scroll = this.container_width - this.items_pixel;
			this.bounce_distance = 20; // Bounce intensity (pixels)
			this.current_x = this.max_scroll; // Start scrolled to end (right-aligned)
			this.is_dragging = false;
			this.animation_frame;
			this.velocity = 0;
			this.last_x = 0;
		}
	}
	
	init() {
		this.hammer_gestures_active ? this.hammer_gestures() : this.simple_scroll();
	}
	simple_scroll() {
		this.$list.css('overflow', 'auto');
		this.$list[0].scrollLeft = this.$list[0].scrollWidth;
	}
	hammer_gestures() {
		if (
			typeof Hammer === 'undefined' ||
			!this.$breadcrumb_inner.length
		) {
			return;
		}

		const resizeObserver = new ResizeObserver(entries => {
			this.items_pixel = this.calculate_width();
			this.container_width = this.$breadcrumb_inner.width();
			this.max_scroll = this.container_width - this.items_pixel;
			this.current_x = this.max_scroll; // Start scrolled to end (right-aligned)
			if (this.max_scroll >= 0) {
				hammer.set({ enable: false });
			}
			// Initialize position (scroll to end)
			this.on_pan_end();
		});
		this.$breadcrumb_inner.find('li').each((i, el) => {
			resizeObserver.observe(el);
		});
		
		const hammer = new Hammer(this.$breadcrumb_inner[0], {});
		
		hammer.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 });
		
		if (this.max_scroll >= 0) {
			hammer.set({ enable: false });
		}
		// Initialize position (scroll to end)
		this.on_pan_end();
		
		hammer.on('panstart', this.on_pan_start.bind(this));
		hammer.on('panmove', this.on_pan_move.bind(this));
		hammer.on('panend', this.on_pan_end.bind(this));
	}
	on_pan_start(e) {
		e.preventDefault();
		this.is_dragging = true;
		cancelAnimationFrame(this.animation_frame); // Stop inertia
	}
	
	calculate_width() {
		let pixels = 0;
		this.$breadcrumb_inner.find('li').each(function(i, e) {
			pixels += jQuery(e).outerWidth(true); // Includes margins/padding
			pixels += this.container_gap;
		}.bind(this));
		return pixels;
	}
	
	on_pan_move(e) {
		e.preventDefault();
		
		if (!this.is_dragging) {
			return;
		}
		
		// Calculate new position with bounce effect
		let new_x = this.current_x + e.deltaX;
		
		if (new_x > 0) {
			new_x = this.apply_bounce(new_x, 0, this.bounce_distance);
		} else if (new_x < this.max_scroll) {
			new_x = this.max_scroll - this.apply_bounce(this.max_scroll - new_x, 0, this.bounce_distance);
		}
		
		this.apply_transform(new_x);
		this.velocity = e.deltaX - this.last_x; // For inertia
		this.last_x = e.deltaX;
	}
	
	on_pan_end(e) {
		if (e) {
			e.preventDefault();
		}
		this.is_dragging = false;
		this.snap_back();
	}
	
	apply_transform(x) {
		this.current_x = x;
		this.$breadcrumb_inner.css({
			'transform': `translateX(${x}px)`,
			'transition': this.is_dragging ? 'none' : 'transform 0.3s ease-out'
		});
	}
	
	// Rubber-band bounce effect
	apply_bounce(value, min, max) {
		if (value < min) {
			return min - (min - value) * 0.3; // Soften bounce
		}
		if (value > max) {
			return max + (value - max) * 0.3;
		}
		return value;
	}
	
	// Snap back to boundaries
	snap_back() {
		let target_x = this.current_x;
		
		if (this.current_x > 0) {
			target_x = 0;
		} else if (this.current_x < this.max_scroll) {
			target_x = this.max_scroll;
		}
		this.apply_transform(target_x);
	}
}

Object.keys(yalwa.v.components).forEach(component_key => {
	if (component_key.startsWith('breadcrumb')) {
		new Breadcrumb(component_key).init();
	}
});